module.exports = __webpack_public_path__ + "static/media/8.a7382498.png";